var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},[_c('span',{staticClass:"toast-container__message"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('MyActionBtn',{attrs:{"btnText":_vm.buttonName,"size":_vm.isUnderOrEqualViewport1024 ? 'small' : 'medium'},on:{"click":_vm.triggerActionBtn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }